import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';

import ModalContainer from '@components/modals/ModalContainer';
import { toastSuccess } from '@components/Toast';

import { closeLoader, openLoader } from '@store/actions/LoaderAction';

import { getPresentationSequenceEmailContent } from '@services/collectionService';

import { getBuyerAppBaseFrontendUrl } from '@/constants/constant';

const SendMailToBuyer = ({ isOpenModal, brandName, onClose, collectionId, entityType, presentationId }) => {
	const [selectedMentionedUser, setSelectedMentionedUser] = useState([]);
	const [coverDocument, setCoverDocument] = useState({});
	const [mentionToUser, setMentionToUser] = useState([]);
	const [allUser, setAllUser] = useState([]);
	const [mentionSearch, setMentionSearch] = useState('');
	const dropdownRef = useRef(null);
	const searchRef = useRef(null);
	const dispatch = useDispatch();

	const fetchEmailContent = async () => {
		try {
			dispatch(openLoader());
			const data = await getPresentationSequenceEmailContent(presentationId, entityType);
			setSelectedMentionedUser(data.userResponseList?.filter((item) => item.isShare === true));
			setMentionToUser(data.userResponseList?.filter((item) => item.isShare === false));
			setAllUser(data.userResponseList);
			setCoverDocument(data.coverDocument);
			dispatch(closeLoader());
		} catch {
			dispatch(closeLoader());
		}
	};

	useEffect(() => {
		fetchEmailContent();
	}, []);

	const handleCopy = () => {
		let sourceDiv = document.getElementById('sourceDiv');
		let range = document.createRange();
		range.selectNode(sourceDiv);

		let selection = window.getSelection();
		selection.removeAllRanges();
		selection.addRange(range);

		document.execCommand('copy');
		selection.removeAllRanges();
		toastSuccess('Copy successful!');
	};

	const onDismissSelection = (userId) => {
		const userDismiss = selectedMentionedUser;
		const index = selectedMentionedUser.findIndex((el) => el.id === userId);
		userDismiss.splice(index, 1);
		setSelectedMentionedUser(userDismiss);
		setMentionToUser([]);
		setMentionSearch('');
	};

	const selectedUserToMention = (value) => {
		if (mentionToUser && mentionToUser.length > 0) {
			const mentionedUsers = selectedMentionedUser;
			const selectedUser = mentionToUser.filter((el) => el.email === value);
			if (selectedUser[0]) {
				mentionedUsers.push(selectedUser[0]);
				setSelectedMentionedUser(mentionedUsers);
				setMentionToUser([]);
				setMentionSearch('');
			}
		}
	};

	const handleMentionTo = async (e) => {
		setMentionSearch(e.target.value);
		if (e.target.value) {
			let newData = allUser.filter(
				(user) => !selectedMentionedUser.some((item) => user.email === item.email)
			);
			setMentionToUser(newData);
		}
	};

	const onMailAddressCopy = () => {
		let emails = selectedMentionedUser.map((item) => item.email).join(',');
		navigator.clipboard.writeText(emails);
	};

	const getMailUrl = () => {
		return getBuyerAppBaseFrontendUrl() + '/collections-presentation/' + collectionId;

		/*
    const hostName = window.location.toString();
    if (hostName.indexOf('https://admin.nitex.com') > -1) {
      return 'https://app.nitex.com/collections-presentation/' + collectionId;
    } else {
      return 'https://test.nitex.com/collections-presentation/' + collectionId;
    }

     */
	};

	return (
		<>
			{isOpenModal && (
				<ModalContainer onCloseModal={onClose}>
					<div className="common-popup send-email-modal shadow-24dp">
						<div className="common-popup-header d-flex justify-content-between">
							<div className="popup-tilte">
								<h3 className="semibold-16 mb-0">Step 3 :Send mail to buyer </h3>
							</div>
							<div className="close-btn">
								<img
									src={`${process.env.PUBLIC_URL}/icons/close.svg`}
									alt="close"
									onClick={onClose}
								/>
							</div>
						</div>
						<div className="common-popup-body">
							<div className="mention-container border-bottom-solid pb-2">
								<div className="tag-person to-fixed">
									<div className="tag-items">
										<div className="d-flex flex-wrap">
											<p className="mr-2 mb-1">To: </p>
											{selectedMentionedUser &&
												selectedMentionedUser.map((user) => {
													return (
														<span
															key={user.id}
															className="status blue-3 mr-1 mb-1"
														>
															{user.email}
															<img
																src={`${process.env.PUBLIC_URL}/icons/close-14.svg`}
																onClick={() => onDismissSelection(user.id)}
																className="ml-1"
															/>
														</span>
													);
												})}
											{selectedMentionedUser.length > 0 && (
												<p
													className="ml-2 mb-1 cursor-pointer"
													onClick={onMailAddressCopy}
												>
													Copy{' '}
												</p>
											)}
										</div>
										<div>
											<div className="metion-person-suggetion scroll-y-label">
												<ul className="scroll-y-label shadow-lg" ref={dropdownRef}>
													{mentionSearch.length > 0 &&
														mentionToUser.map((user) => {
															return (
																<li
																	key={user.id}
																	className="cursor-pointer px-3 py-1"
																	onClick={() =>
																		selectedUserToMention(user.email)
																	}
																	onKeyPress={(e) => {
																		if (e.key === 'Enter') {
																			selectedUserToMention(user.email);
																		}
																	}}
																>
																	<span
																		className="single-item-focus"
																		tabIndex={0}
																	>
																		{user.email}
																	</span>
																</li>
															);
														})}
												</ul>
											</div>
											<input
												className="mention-search-box no-border pl-0 mt-2"
												value={mentionSearch}
												placeholder="Search with email"
												type="text"
												autoComplete="off"
												onChange={handleMentionTo}
												ref={searchRef}
											/>
										</div>
									</div>
								</div>
							</div>
							<div style={{ padding: '24px 0' }} id="sourceDiv">
								<h3
									style={{
										fontSize: '20px',
										lineHeight: '28px',
										fontWeight: 700,
										color: '#21242B'
									}}
								>
									Hey
								</h3>
								<p
									style={{
										fontSize: '14px',
										lineHeight: '20px',
										fontWeight: 400,
										color: '#21242B'
									}}
								>
									I hope this message finds you well. It&#39;s a pleasure to connect with
									you once again as I share something special. <br />I am excited to share
									this latest fashion collection with you, meticulously designed to resonate
									with &nbsp;
									<b>{brandName}</b>. I believe this collection will seamlessly complement
									your ranges in this season.
								</p>
								<a
									style={{
										fontSize: '14px',
										lineHeight: '20px',
										padding: '8px 12px',
										color: '#ffffff',
										background: '#21242B',
										border: 'none',
										marginTop: '24px',
										display: 'inline-block'
									}}
									href={getMailUrl()}
									target={'_blank'}
									rel="noreferrer"
								>
									View Presentation
								</a>
								<div style={{ margin: '32px 0' }}>
									{coverDocument?.docUrl && (
										<img
											src={coverDocument.docUrl}
											alt="photo"
											style={{
												width: '440px',
												height: '280px',
												objectFit: 'contain',
												objectPosition: 'left'
											}}
										/>
									)}
								</div>
								<div>
									<h4
										style={{
											fontSize: '16px',
											lineHeight: '24px',
											fontWeight: 500,
											color: '#21242B',
											marginBottom: 0
										}}
									>
										Best Regards
									</h4>
									<p
										style={{
											fontSize: '14px',
											lineHeight: '20px',
											fontWeight: 400,
											color: '#21242B'
										}}
									>
										Nitex Team
									</p>
								</div>
							</div>
						</div>
						<div className="modal-footer">
							<div className="footer-buttons text-right">
								<button className="button gray-outline size32" onClick={handleCopy}>
									Copy
								</button>
							</div>
						</div>
					</div>
				</ModalContainer>
			)}
		</>
	);
};

export default SendMailToBuyer;
